/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

// Ideally these values would flow from CE
// TODO: Update this if and when these values are available from CE.
export const COMPETITOR_WHITELIST_TYPES = ["866100001", "866100004", "866100003"];

export const CAMPAIGN_FIELD_NAMES = {
  RESPONSE_CODE: "responseCode",
  REASON: "reason",
  TYPE: "type",
  COMPETITOR: "competitor",
  NOTES: "notes",
} as const;

import { Path } from "react-hook-form";

import { CampaignFormData } from "./types";

type CampaignFormRecord = Record<string, CampaignFormData>;

/**
 * Builds a form field path for a campaign field
 * @param campaignKey - The campaign key (campaignId or index)
 * @param fieldName - The field name from CAMPAIGN_FIELD_NAMES
 * @returns The full field path (e.g., "campaign-id-1.reason")
 */
export const buildCampaignFieldPath = <TFieldName extends keyof CampaignFormData>(
  campaignKey: string,
  fieldName: TFieldName
): Path<CampaignFormRecord> => {
  return `${campaignKey}.${fieldName}` as Path<CampaignFormRecord>;
};
